import * as Sentry from "@sentry/react";
import { setErrorReporter } from "./errorReporter";

export default function initSentryWeb() {
  // CRA expõe NODE_ENV ("development" | "production"). __DEV__ não existe no web.
  const environment = process.env.NODE_ENV || "development";
  const isProd = environment === "production";

  Sentry.init({
    dsn:
      process.env.REACT_APP_SENTRY_DSN_WEB ||
      "https://c26c1f9d6417b80d3cd39a9e27c16deb@o4509666478718976.ingest.us.sentry.io/4511139327180800",
    environment,
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    // Sem esta integração o tracesSampleRate é inerte — nenhum trace é gerado.
    integrations: [Sentry.browserTracingIntegration()],
    // Amostra baixa em produção para controlar custo/quota; tudo em desenvolvimento.
    tracesSampleRate: isProd ? 0.1 : 1.0,
    // Não enviar IP/dados pessoais por padrão (app lida com PII: CPF/RG/placa).
    sendDefaultPii: false,
  });

  // Liga a ponte genérica: qualquer reportError(err, ctx) do app vai para o Sentry.
  setErrorReporter((error, context) => {
    Sentry.captureException(error, { extra: context });
  });

  Sentry.setTag("app", "web");
}
